import { render } from "./FolderStructure.vue?vue&type=template&id=86db651c&scoped=true&ts=true"
import script from "./FolderStructure.vue?vue&type=script&lang=ts"
export * from "./FolderStructure.vue?vue&type=script&lang=ts"

import "./FolderStructure.vue?vue&type=style&index=0&id=86db651c&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86db651c"]])

export default __exports__